// extracted by mini-css-extract-plugin
export default {"root":"styles_root__39X4+","dragging-over":"styles_dragging-over__TPQhZ","draggingOver":"styles_dragging-over__TPQhZ","color":"styles_color__dk7Fc"};